/**
 * @format
 */
import { ConnectionProfilesActions } from "../../../../../../../ngapp/src/app/connection-profile/state/connection-profiles.actions";
angular
    .module("autoremind.satellites")
    .directive("satelliteSetup", [
    "$rootScope",
    "$location",
    "$interval",
    "logger",
    "satelliteService",
    "dialogs",
    "accountService",
    "$timeout",
    "$q",
    "storeDowngraded",
    "connectionProfilesSelectorsDowngraded",
    "$translate",
    function ($rootScope, $location, $interval, logger, satelliteService, dialogs, accountService, $timeout, $q, storeDowngraded, connectionProfilesSelectorsDowngraded, $translate) {
        return {
            restrict: "E",
            templateUrl: "app/admin/satellites/satellite-setup/satellite-setup.html",
            scope: {
                parentViewModel: "=",
                activated: "=",
                selectedUser: "=",
            },
            link: function ($scope, element, attrs) {
                $scope.user = {};
                $scope.updateInterval = null;
                $scope.viewModel = $scope.parentViewModel.tabViews.setup;
                $scope.viewModel.isEditedDataSource = false;
                $scope.dataSource = {};
                $scope.initialSateDataSource = {};
                $scope.viewModel.isModulenameCanBeEdited = true;
                $scope.viewModel.isCheckingModulename = false;
                $scope.viewModel.selectedSatellite = null;
                $scope.viewModel.selectedClientModule = null;
                $scope.viewModel.wrongAppointmentStates = false;
                $scope.viewModel.selectedUser = {};
                $scope.viewModel.usersList = [];
                $scope.viewModel.setToFull = false;
                // As we might load several things, the indicator is a counter that tracks how many things we still need to load
                $scope.viewModel.loadingIndicator = 0;
                $scope.viewModel.loadingIndicatorv2 = { state: false, refCount: 0 };
                $scope.viewModel.disableSave = false;
                $scope.viewModel.defDataSources = {
                    ACTData: {
                        actDataAuthURL: "https://animalcaretech.us.auth0.com/oauth/token",
                        actDataBaseApiUrl: "https://vsmart.vsurv.com/api/data/graphql",
                        actDataClientId: "GiVbZ9jePCxtfbqQPHayFHIa2VypTfEu",
                        actDataSyncAppointmentsFromDaysBack: null,
                        actDataSyncAppointmentsFromDaysForward: null,
                        actDataDisableAutomatedReconcile: true,
                        actDataStarted: false,
                        useTypeFieldForAppointmentReasons: false,
                        TraceInfo: false,
                    },
                    OpenDental: {
                        dataSourceUrl: "jdbc:mysql://127.0.0.1:3306/opendental",
                        username: "root",
                        password: ""
                    }
                };
                $scope.viewModel.selectedUserInfo = $scope.parentViewModel.selectedUserInfo;
                $scope.satelliteVersionLatest = "";
                $scope.satelliteLogServiceUIUrl = null;
                $scope.minimumSatelliteVersion = 2217;
                $scope.viewModel.enableLoadStrategy = false;
                $scope.viewModel.isVets = false;
                $scope.viewModel.autoremindAccount = undefined;
                $scope.decreaseLoadingIndicator = function () {
                    if ($scope.viewModel.loadingIndicator > 0) {
                        $scope.viewModel.loadingIndicator--;
                    }
                    if ($scope.parentViewModel.loadingIndicator !== undefined) {
                        $scope.parentViewModel.loadingIndicator.refCount--;
                        $scope.parentViewModel.loadingIndicator.state =
                            $scope.parentViewModel.loadingIndicator.refCount > 0;
                    }
                };
                $scope.increaseLoadingIndicator = function () {
                    $scope.viewModel.loadingIndicator++;
                    if ($scope.parentViewModel.loadingIndicator !== undefined) {
                        $scope.parentViewModel.loadingIndicator.refCount++;
                        $scope.parentViewModel.loadingIndicator.state =
                            $scope.parentViewModel.loadingIndicator.refCount > 0;
                    }
                };
                /**
                 *
                 */
                $scope.getSatellites = function (shouldStopUpdate, successMessage) {
                    $scope.increaseLoadingIndicator();
                    // satelliteService.getSatellites($scope.viewModel.selectedUserInfo.userName)
                    satelliteService.getSatellites($scope.viewModel.selectedUser.userName).then(function (satellites) {
                        $scope.decreaseLoadingIndicator();
                        if (shouldStopUpdate) {
                            $scope.stopUpdate();
                        }
                        $scope.viewModel.selectedSatellite = null;
                        $scope.updateSatellites(satellites);
                        logger.debug("Got " + $scope.viewModel.satellites.length + " satellites");
                        if ($scope.viewModel.satellites.length === 1) {
                            $scope.viewModel.satellite = $scope.viewModel.satellites[0];
                            $scope.selectSatellite(satellites[0]);
                        }
                        satelliteService.getLatestVersion().then(function () {
                            $scope.satelliteVersionLatest = satelliteService.satelliteVersionLatest;
                        });
                        satelliteService.getLogServiceUIUrl().then(function () {
                            $scope.satelliteLogServiceUIUrl = satelliteService.satelliteLogServiceUIUrl;
                        });
                        if (successMessage) {
                            dialogs.notify("Success", successMessage);
                        }
                    }, function () {
                        // Error getting satellites
                        $scope.decreaseLoadingIndicator();
                        if (shouldStopUpdate) {
                            $scope.stopUpdate();
                        }
                    });
                };
                $scope.swallowEvent = function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                };
                $scope.getSelectedUserData = function (user, moduleName) {
                    $scope.viewModel.autoremindAccount = undefined;
                    satelliteService
                        .checkIfUserAlreadyHaveDatasource(user.name, moduleName, $scope.viewModel.loadingIndicatorv2)
                        .then(function (response) {
                        if (!response.exist) {
                            $scope.dataSource.autoremindAccount = user.name;
                            $scope.viewModel.autoremindAccount = user.name;
                            $scope.viewModel.isEditedDataSource = true;
                            $scope.viewModel.disableSave = false;
                        }
                        else {
                            dialogs.notify("Alert", 'A datasource with account name: "' +
                                user.name +
                                '" already exists for autoremind account(s):.' +
                                response.accountForWhichSatelliteHaveDatasource);
                            $scope.viewModel.autoremindAccount = $scope.dataSource.autoremindAccount;
                            $scope.viewModel.disableSave = true;
                        }
                    });
                };
                $scope.searchUsersList = function (pattern) {
                    $scope.viewModel.detailsVisible = false;
                    $scope.viewModel.autoremindAccount = undefined;
                    return accountService.searchUser(pattern, $scope.viewModel.loadingIndicatorv2).then(function (users) {
                        return ($scope.viewModel.usersList = users);
                    });
                };
                /**
                 * Output displayed by the type-ahead patient search field
                 */
                $scope.userFormatInput = function (model) {
                    if (model === null || !angular.isDefined(model)) {
                        return "";
                    }
                    if (model.name !== undefined) {
                        return model.name;
                    }
                    return model;
                };
                $scope.toggleEditVersionMode = function (satellite, mode) {
                    var index = $scope.viewModel.satellites.indexOf(satellite);
                    var item = $scope.viewModel.satellites[index];
                    item.versionEditModeOn = mode;
                };
                /**
                 * Edit version mode
                 */
                $scope.switchEditModeOn = function (satellite, event) {
                    $scope.swallowEvent(event);
                    $scope.toggleEditVersionMode(satellite, true);
                };
                $scope.switchEditModeOff = function (satellite, event) {
                    $scope.swallowEvent(event);
                    $scope.toggleEditVersionMode(satellite, false);
                };
                $scope.isEditModeSwitchedOn = function (satellite) {
                    var isOn = false;
                    angular.forEach($scope.viewModel.satellites, function (val, key) {
                        if (satellite.satelliteName === val.satelliteName) {
                            isOn = val.versionEditModeOn;
                        }
                    });
                    return isOn === true;
                };
                /**
                 * Set item version to the last Satellite version
                 */
                $scope.useLastestVersion = function (event, satellite) {
                    satellite.newVersionEdited = $scope.satelliteVersionLatest;
                    $scope.swallowEvent(event);
                };
                /**
                 * Set satellite version number
                 */
                $scope.setVersionNumber = function (satellite, event) {
                    $scope.swallowEvent(event);
                    $scope.increaseLoadingIndicator();
                    satelliteService.setSatelliteVersion(satellite).then(function (result) {
                        $scope.decreaseLoadingIndicator();
                        console.info("Satellite [" +
                            result.satellite.satelliteName +
                            "] updated. Rows affected: [" +
                            result.rowsAffected +
                            "]");
                        $scope.getSatellites(true);
                    });
                };
                $scope.setNewVersionEditable = function (satellite, mode) {
                    var index = $scope.viewModel.satellites.indexOf(satellite);
                    var item = $scope.viewModel.satellites[index];
                    item.versionEditModeOn = mode;
                    if (mode === true) {
                        satellite.newVersionEdited = satellite.newVersion;
                    }
                };
                $scope.isNewVersionEditable = function (selectedSatellite) {
                    var editable = false;
                    angular.forEach($scope.viewModel.satellites, function (satellite, key) {
                        if (selectedSatellite.satelliteId === satellite.satelliteId) {
                            editable = satellite.versionEditModeOn;
                        }
                    });
                    return editable === true;
                };
                $scope.newVersionKeyUp = function (satellite, $event) {
                    if ($event.keyCode === 27) {
                        $event.preventDefault();
                        $scope.setNewVersionEditable(satellite, false);
                        satellite.newVersionEdited = satellite.newVersion;
                    }
                };
                /**
                 * Set satellite version number
                 */
                $scope.setSatelliteNewVersion = function (satellite, event) {
                    $scope.swallowEvent(event);
                    satellite.newVersion = satellite.newVersionEdited;
                    $scope.increaseLoadingIndicator();
                    satelliteService
                        .setSatelliteNewVersion(satellite.satelliteId, satellite.newVersion, satellite.satelliteVersion)
                        .then(function (result) {
                        $scope.decreaseLoadingIndicator();
                        console.info("Satellite [" +
                            satellite.satelliteId +
                            "] updated. Rows affected: [" +
                            result.rowsAffected +
                            "]");
                        $scope.getSatellites(true, "The satellite will be instructured to upgrade to this new version.");
                    });
                };
                /**
                 * Version must be at least 0.11 to support AutoUpgrade (to newVersion)
                 */
                $scope.isAutoUpgradeSupported = function (satelliteVersion) {
                    if (!satelliteVersion) {
                        return false;
                    }
                    var versionParts = satelliteVersion.split(".");
                    var versionMajor = +versionParts[0];
                    var versionMinor = +versionParts[1];
                    return versionMajor > 0 || versionMinor >= 11;
                };
                /**
                 * Version must be at least 3.0.2811 to support log transfer
                 */
                $scope.isLogTransferSupported = function (satelliteVersion) {
                    if (!satelliteVersion) {
                        return false;
                    }
                    var versionParts = satelliteVersion.split(".");
                    if (versionParts.length < 3) {
                        return false;
                    }
                    var versionMajor = +versionParts[0];
                    var versionMinor = +versionParts[1];
                    var buildNo = +versionParts[2];
                    if (versionMajor > 3) {
                        return true;
                    }
                    if (versionMajor === 3) {
                        return versionMinor > 0 || buildNo >= 2811;
                    }
                    return false;
                };
                $scope.updateSatellites = function (satellites) {
                    var satellitesUpdated = [];
                    angular.forEach(satellites, function (satellite, key) {
                        satellite.versionEditModeOn = false;
                        satellitesUpdated.push(satellite);
                    });
                    $scope.viewModel.satellites = satellitesUpdated;
                };
                $scope.getSatellite = function (satellite) {
                    $scope.increaseLoadingIndicator();
                    $translate.use("en_person");
                    if ($scope.viewModel.selectedUser.userPermissions !== undefined) {
                        for (var i = 0; i < $scope.viewModel.selectedUser.userPermissions.length; i++) {
                            if ($scope.viewModel.selectedUser.userPermissions[i].permissionKey === "resource:pets") {
                                $scope.viewModel.isVets = true;
                                $translate.use("en_vets");
                                break;
                            }
                        }
                    }
                    satelliteService.getSatellite(satellite.satelliteId, $scope.viewModel.selectedUser.userName).then(function (satellites) {
                        $scope.decreaseLoadingIndicator();
                        //$scope.updateSatellites(satellites);
                        if (satellites.length > 0) {
                            // selectedSatellite may have changes since calling the servlet, so find and update the right one
                            for (var i = 0; i < $scope.viewModel.satellites.length; i++) {
                                var viewedSatellite = $scope.viewModel.satellites[i];
                                // NOTE: Index 0 since call to servlet by specific satelliteName will return a list but only with one satellite
                                var loadedSatellite = satellites[0];
                                if (viewedSatellite.satelliteName === loadedSatellite.satelliteName) {
                                    // Update values and not reference to satellite object to keep the selected object in the view
                                    logger.debug("Updating viewed satellite " +
                                        viewedSatellite.satelliteName +
                                        " with data fetched from server");
                                    viewedSatellite.satelliteState = loadedSatellite.satelliteState;
                                    viewedSatellite.checkinMode = loadedSatellite.checkinMode;
                                    viewedSatellite.checkinInterval = loadedSatellite.checkinInterval;
                                    viewedSatellite.latestCheckin = loadedSatellite.latestCheckin;
                                    viewedSatellite.nextCheckin =
                                        viewedSatellite.latestCheckin + viewedSatellite.checkinInterval;
                                    //viewedSatellite.checkinTimeLeft = viewedSatellite.latestCheckin + viewedSatellite.checkinInterval;
                                    viewedSatellite.transactionId = loadedSatellite.transactionId;
                                    viewedSatellite.transactionStarted = loadedSatellite.transactionStarted;
                                    viewedSatellite.transactionExpectedCompletion =
                                        loadedSatellite.transactionExpectedCompletion;
                                    viewedSatellite.transactionExpected =
                                        loadedSatellite.transactionStarted + loadedSatellite.transactionExpectedCompletion;
                                    if (viewedSatellite.transactionExpectedCompletion > 0 &&
                                        viewedSatellite.satelliteState === "busy") {
                                        viewedSatellite.transactionProgressMessage = "Storing data from Satellite...";
                                    }
                                    else {
                                        viewedSatellite.transactionProgressMessage = "Waiting for next update...";
                                    }
                                    if (viewedSatellite.transactionExpectedCompletionMax === undefined ||
                                        viewedSatellite.transactionExpectedCompletionMax <
                                            loadedSatellite.transactionExpectedCompletion) {
                                        viewedSatellite.transactionExpectedCompletionMax =
                                            loadedSatellite.transactionExpectedCompletion;
                                    }
                                    else if (loadedSatellite.transactionExpectedCompletion === 0) {
                                        // Reset for next run
                                        viewedSatellite.transactionExpectedCompletionMax = 1;
                                        viewedSatellite.transactionExpectedCompletionProgress = 100;
                                    }
                                    viewedSatellite.transactionExpectedCompletionProgress =
                                        100 -
                                            (viewedSatellite.transactionExpectedCompletion * 100) /
                                                viewedSatellite.transactionExpectedCompletionMax;
                                    if (viewedSatellite.clientModules === undefined ||
                                        (loadedSatellite.clientModules !== undefined &&
                                            viewedSatellite.clientModules.length !== loadedSatellite.clientModules.length)) {
                                        // If we got more/less modules from server then replace old with loaded list
                                        // NOTE: This will reset any selection in the UI
                                        //       (this will happen if adding/deleting or if another user is editing the list at the same time)
                                        viewedSatellite.clientModules = loadedSatellite.clientModules;
                                        // TODO: Do more intelligent comparison and add/insert/remove differences while still keeping old objects
                                    }
                                    else if (loadedSatellite.clientModules === undefined &&
                                        viewedSatellite.clientModules.length > 0) {
                                        // Clear list
                                        viewedSatellite.clientModules = [];
                                    }
                                    else {
                                        var viewedIndex = 0;
                                        if (loadedSatellite.clientModules !== undefined) {
                                            for (var loadedIndex = 0; loadedIndex < loadedSatellite.clientModules.length; loadedIndex++) {
                                                var viewedModule = viewedSatellite.clientModules[viewedIndex];
                                                var loadedModule = loadedSatellite.clientModules[loadedIndex];
                                                viewedModule.clientModuleId = loadedModule.clientModuleId; // NOTE: This should not be necessary
                                                viewedModule.updateMode = loadedModule.updateMode;
                                                viewedModule.updateInterval = loadedModule.updateInterval;
                                                viewedModule.latestUpdate = loadedModule.latestUpdate;
                                                viewedModule.nextUpdate =
                                                    viewedModule.latestUpdate + viewedModule.updateInterval;
                                                viewedModule.appointmentCount = loadedModule.appointmentCount;
                                                viewedModule.personCount = loadedModule.personCount;
                                                viewedModule.reasonCount = loadedModule.reasonCount;
                                                viewedModule.petCount = loadedModule.petCount;
                                                // TODO: deep copy dataSourceJSON?
                                                viewedModule.dataSourceJSON = loadedModule.dataSourceJSON;
                                                viewedIndex++;
                                            }
                                        }
                                    }
                                    // If only one client module then auto-select it
                                    if (viewedSatellite.clientModules !== undefined &&
                                        viewedSatellite.clientModules.length === 1 &&
                                        $scope.viewModel.selectedClientModule == null) {
                                        $scope.viewModel.selectedClientModule = viewedSatellite.clientModules[0];
                                    }
                                    // If a client module is selected then update the model for the form to edit config
                                    if ($scope.viewModel.selectedClientModule !== null) {
                                        $scope.setDataSource($scope.viewModel.selectedClientModule);
                                    }
                                }
                            }
                            // If a satellite is already selected then also get the log events
                            if (angular.isDefined($scope.viewModel.selectedSatellite)) {
                                //Sep182015                    $scope.getLogEvents($scope.viewModel.selectedSatellite);
                            }
                        }
                        else {
                            // No satellites, so suggest to add a new
                            // xxx
                        }
                        $scope.updateInProgress = false; // In case this was called in an update loop then allow another update
                    }, function () {
                        $scope.decreaseLoadingIndicator();
                        $scope.updateInProgress = false; // In case this was called in an update loop then allow another update
                    }); // end of async success handler
                };
                /**
                 *
                 */
                $scope.selectSatellite = function (satellite) {
                    logger.debug("selectSatellite: satelliteName: " + satellite.satelliteName);
                    $scope.viewModel.selectedClientModule = null;
                    $scope.clearDataSource();
                    $scope.viewModel.selectedSatellite = satellite;
                    $scope.dataSource.initialized = false;
                    //$scope.getSatellite(satellite);
                    // Enable updating if not already enabled
                    $scope.update();
                    // Load the selected satellite right away and disable update just until the data is loaded
                    $scope.updateInProgress = true;
                    $scope.getSatellite($scope.viewModel.selectedSatellite, $scope.viewModel.selectedUser.userName);
                };
                $scope.relaunchSatellite = function (satellite) {
                    logger.debug("relaunchSatellite: satelliteName: " + satellite.satelliteName);
                    satellite.checkinMode = "restart";
                    var dialog = dialogs.confirm("Confirm", "Are you sure you want to restart the satellite?");
                    dialog.result.then(function (button) {
                        // Yes
                        $scope.increaseLoadingIndicator();
                        satelliteService.setSatelliteCheckinMode(satellite.satelliteId, satellite.checkinMode).then(function () {
                            $scope.decreaseLoadingIndicator();
                            dialogs.notify("Success", "The satellite will now be instructed to restart...");
                        }, function (button) {
                            // No
                        });
                    });
                };
                $scope.transferLogs = function (satellite, mode) {
                    logger.debug("transferLogs: satelliteName: " + satellite.satelliteName);
                    $scope.increaseLoadingIndicator();
                    satelliteService.transferLogs(satellite.satelliteId, mode).then(function () {
                        $scope.decreaseLoadingIndicator();
                        dialogs.notify("Success", "The satellite will now be instructed to send logs");
                    }, function (error) {
                        $scope.decreaseLoadingIndicator();
                        $scope.viewModel.isError = true;
                        $scope.viewModel.error = error.error.reason;
                        $scope.viewModel.errorMessage = "Error instructing satellite to send logs";
                        $scope.showError();
                        deferred.reject(error);
                    });
                };
                $scope.stopSatellite = function (satellite) {
                    logger.debug("stopSatellite: satelliteName: " + satellite.satelliteName);
                };
                $scope.stopHandler = null;
                $scope.updateInProgress = false;
                $scope.update = function () {
                    // Don't start a new update if updating has already been enabled
                    if (angular.isDefined($scope.stopHandler) && $scope.stopHandler)
                        return;
                    $scope.stopHandler = $interval(function () {
                        if (!$scope.viewModel.selectedSatellite || $location.path() !== "/admin/satellites/setup") {
                            $interval.cancel($scope.stopHandler);
                        }
                        // Don't update if an update is already in progress
                        if ($scope.updateInProgress)
                            return;
                        $scope.updateInProgress = true;
                        $scope.viewModel.polling = true;
                        ///$scope.increaseLoadingIndicator();
                        /*
                            satelliteService.getSatellites()
                            .then(function(satellites) {
                            $scope.updateSatellites(satellites);
                            $scope.viewModel.loadingIndicator = false;
                            logger.debug('Got ' + $scope.viewModel.satellites.length + ' satellites');
                            if (satellites.length > 0) {
                            $scope.viewModel.satellite = $scope.viewModel.satellites[0];
                            }
                            }, function() {
                            $scope.viewModel.loadingIndicator = false;
                            });
                            */
                        if ($scope.viewModel.selectedSatellite !== undefined && $scope.viewModel.selectedSatellite) {
                            $scope.getSatellite($scope.viewModel.selectedSatellite, $scope.viewModel.selectedUser.userName);
                            /*.then(function() {
                                 ;//
                                 }, function() {
                                 updateInProgress = false;
                                 $scope.viewModel.loadingIndicator = false;
                                 });*/
                        }
                        else {
                            $scope.updateInProgress = false;
                        }
                    }, 5000);
                };
                $scope.stopUpdate = function () {
                    // $scope.viewModel.selectedSatellite = null;
                    if (angular.isDefined($scope.stopHandler)) {
                        var cancel = $interval.cancel($scope.stopHandler);
                        $scope.stopHandler = null;
                        $scope.viewModel.polling = false;
                    }
                };
                // Setup watch on changing location events - to stop timer
                $scope.$on("$locationChangeStart", function () {
                    $scope.stopUpdate();
                });
                /* Not Used
                $scope.toggleUpdate = function () {
                   if (angular.isDefined(stopHandler)) {
                      $interval.cancel(stopHandler);
                      stopHandler = undefined;
                      $scope.viewModel.polling = false;
                      // Remember state of progress bar
                   } else {
                      $scope.viewModel.polling = true;
                      //$scope.update();
                      // Restore state of progress bar
                   }
                };
                */
                $scope.selectClientModule = function (clientModule) {
                    logger.debug("selectClientModule: moduleName: " + clientModule.moduleName);
                    // if ($scope.viewModel.selectedClientModule != clientModule) {
                    $scope.viewModel.isEditedDataSource = false;
                    $scope.viewModel.selectedClientModule = clientModule;
                    $scope.dataSource.initialized = false;
                    $scope.viewModel.isModulenameCanBeEdited = true;
                    $scope.viewModel.isCheckingModulename = false;
                    $scope.setDataSource($scope.viewModel.selectedClientModule);
                    // }
                };
                $scope.clearDataSource = function () {
                    console.log("clearDataSource", $scope.dataSource.moduleType);
                    var defDataSource = {
                        initialized: false,
                        autoremindAccount: $scope.viewModel.autoremindAccount,
                        updateMode: "full",
                        moduleName: "",
                        updateInterval: "1800000",
                        moduleType: "MicroMD",
                        TraceInfo: false,
                    };
                    var def = {};
                    switch ($scope.dataSource.moduleType) {
                        case "MicroMD":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.MicroMD)
                                ? $scope.viewModel.defDataSources.MicroMD
                                : {});
                            def.moduleType = "MicroMD";
                            break;
                        case "Lytec":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.Lytec)
                                ? $scope.viewModel.defDataSources.Lytec
                                : {});
                            def.moduleType = "Lytec";
                            break;
                        case "MacPractice":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.MacPractice)
                                ? $scope.viewModel.defDataSources.MacPractice
                                : {});
                            def.moduleType = "MacPractice";
                            break;
                        case "Medisoft":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.Medisoft)
                                ? $scope.viewModel.defDataSources.Medisoft
                                : {});
                            def.moduleType = "Medisoft";
                            break;
                        case "Daisy":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.Daisy)
                                ? $scope.viewModel.defDataSources.Daisy
                                : {});
                            def.moduleType = "Daisy";
                            break;
                        case "PracticePartner":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.PracticePartner)
                                ? $scope.viewModel.defDataSources.PracticePartner
                                : {});
                            def.moduleType = "PracticePartner";
                            break;
                        case "SolutionSeries":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.SolutionSeries)
                                ? $scope.viewModel.defDataSources.SolutionSeries
                                : {});
                            def.moduleType = "SolutionSeries";
                            break;
                        case "CrystalPM":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.CrystalPM)
                                ? $scope.viewModel.defDataSources.CrystalPM
                                : {});
                            def.moduleType = "CrystalPM";
                            break;
                        case "Rev360":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.Rev360)
                                ? $scope.viewModel.defDataSources.Rev360
                                : {});
                            def.moduleType = "Rev360";
                            break;
                        case "Aprima":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.Aprima)
                                ? $scope.viewModel.defDataSources.Rev360
                                : {});
                            def.moduleType = "Aprima";
                            break;
                        case "ModMed":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.ModMed)
                                ? $scope.viewModel.defDataSources.ModMed
                                : {});
                            def.moduleType = "ModMed";
                            break;
                        case "Vetter":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.Vetter)
                                ? $scope.viewModel.defDataSources.Vetter
                                : {});
                            def.moduleType = "Vetter";
                            break;
                        case "OfficePracticum":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.OfficePracticum)
                                ? $scope.viewModel.defDataSources.OfficePracticum
                                : {});
                            def.moduleType = "OfficePracticum";
                            break;
                        case "Dentally":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.Dentally)
                                ? $scope.viewModel.defDataSources.Dentally
                                : {});
                            def.moduleType = "Dentally";
                            break;
                        case "ACTData":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.ACTData)
                                ? $scope.viewModel.defDataSources.ACTData
                                : {});
                            def.moduleType = "ACTData";
                            def.actDataSyncAppointmentsFromDaysBack = $scope.getNumberFromString("31");
                            def.actDataSyncAppointmentsFromDaysForward = $scope.getNumberFromString("31");
                            break;
                        case "Dentrix":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.Dentrix)
                                ? $scope.viewModel.defDataSources.Dentrix
                                : {});
                            def.moduleType = "Dentrix";
                            break;
                        case "Shepherd":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.Shepherd)
                                ? $scope.viewModel.defDataSources.Shepherd
                                : {});
                            def.moduleType = "Shepherd";
                            break;
                        case "OpenDental":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.OpenDental)
                                ? $scope.viewModel.defDataSources.OpenDental
                                : {});
                            def.moduleType = "OpenDental";
                            break;
                        case "Eaglesoft":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.Eaglesoft)
                                ? $scope.viewModel.defDataSources.Eaglesoft
                                : {});
                            def.moduleType = "Eaglesoft";
                            break;
                        case "Ascend":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.Ascend)
                                ? $scope.viewModel.defDataSources.Ascend
                                : {});
                            def.moduleType = "Ascend";
                            break;
                        case "Tab32":
                            def = angular.copy(angular.isDefined($scope.viewModel.defDataSources.Tab32)
                                ? $scope.viewModel.defDataSources.Tab32
                                : {});
                            def.moduleType = "Tab32";
                            break;
                    }
                    $scope.dataSource = angular.extend(defDataSource, def);
                    $scope.setInitialStateDataSource($scope.dataSource);
                };
                // TODO: only clear automatically on first load of page
                //$scope.clearDataSource();
                $scope.getNumberFromString = function (value) {
                    if (Boolean(value) && typeof value === "string") {
                        return Number(value);
                    }
                    if (typeof value === "number") {
                        return value;
                    }
                    return null;
                };
                $scope.getJSONStringifyOrEmptyString = function (value) {
                    if (Boolean(value)) {
                        return JSON.stringify(value);
                    }
                    return "";
                };
                $scope.setInitialStateDataSource = function (dataSource) {
                    $scope.initialSateDataSource = Object.assign({}, dataSource);
                };
                $scope.setDataSource = function (clientModule) {
                    if ($scope.dataSource.initialized === false && !$scope.viewModel.isEditedDataSource) {
                        $scope.dataSource.initialized = true;
                        $scope.dataSource.autoremindAccount = clientModule.autoremindAccount;
                        $scope.viewModel.autoremindAccount = clientModule.autoremindAccount;
                        $scope.dataSource.clientModuleId = clientModule.clientModuleId;
                        $scope.dataSource.moduleName = clientModule.moduleName;
                        $scope.dataSource.updateInterval = clientModule.updateInterval;
                        $scope.dataSource.moduleType = clientModule.moduleType;
                        var dataSource = clientModule.dataSourceJSON;
                        $scope.dataSource.lastModifiedSearchOffsetHours = dataSource.lastModifiedSearchOffsetHours;
                        switch (clientModule.moduleType) {
                            case "MicroMD":
                                $scope.dataSource.serviceHostURL = dataSource.serviceHostURL;
                                $scope.dataSource.servicePort = dataSource.servicePort;
                                $scope.dataSource.serviceDatabase = dataSource.serviceDatabase;
                                $scope.dataSource.serviceVirtualDatabase = dataSource.serviceVirtualDatabase;
                                $scope.dataSource.servicePracticeName = dataSource.servicePracticeName;
                                $scope.dataSource.appointmentStates = JSON.stringify(dataSource.appointmentStates);
                                break;
                            case "Lytec":
                                $scope.dataSource.lytecDataSourceURL = dataSource.dataSourceUrl;
                                $scope.dataSource.lytecUsername = dataSource.username;
                                $scope.dataSource.lytecPassword = dataSource.password;
                                break;
                            case "SolutionSeries":
                                $scope.dataSource.solutionSeriesDataSourceURL = dataSource.dataSourceUrl;
                                $scope.dataSource.solutionSeriesUsername = dataSource.username;
                                $scope.dataSource.solutionSeriesPassword = dataSource.password;
                                break;
                            case "MacPractice":
                                $scope.dataSource.macPracticeDataSourceURL = dataSource.dataSourceUrl;
                                $scope.dataSource.macPracticeUsername = dataSource.username;
                                $scope.dataSource.macPracticePassword = dataSource.password;
                                $scope.dataSource.appointmentStates = JSON.stringify(dataSource.appointmentStates);
                                $scope.dataSource.apiUsername =
                                    dataSource.apiUsername !== undefined ? dataSource.apiUsername : "autoremind";
                                $scope.dataSource.apiPassword = dataSource.apiPassword;
                                break;
                            case "Medisoft":
                                $scope.dataSource.medisoftDatasourceName = dataSource.medisoftDatasourceName;
                                $scope.dataSource.medisoftDataDirectory = dataSource.medisoftDataDirectory;
                                $scope.dataSource.medisoftServerType = dataSource.medisoftServerType;
                                $scope.dataSource.medisoftUsername = dataSource.username;
                                $scope.dataSource.medisoftPassword = dataSource.password;
                                $scope.dataSource.rescheduledWaitlistAsCancelled = dataSource.rescheduledWaitlistAsCancelled;
                                break;
                            case "Daisy":
                                $scope.dataSource.daisyDatabaseName = dataSource.databaseName;
                                $scope.dataSource.daisyServerHost = dataSource.serverHost;
                                $scope.dataSource.daisyServerPort = dataSource.portNumber;
                                $scope.dataSource.daisyUsername = dataSource.username;
                                $scope.dataSource.daisyPassword = dataSource.password;
                                $scope.dataSource.daisyHttpUsername = dataSource.httpUsername;
                                $scope.dataSource.daisyHttpPassword = dataSource.httpPassword;
                                $scope.dataSource.TraceInfo = dataSource.traceInfo;
                                $scope.dataSource.appointmentStates = JSON.stringify(dataSource.appointmentStates);
                                break;
                            case "PracticePartner":
                                $scope.dataSource.odbcDatasourceName = dataSource.dbName;
                                $scope.dataSource.odbcUsername = dataSource.username;
                                $scope.dataSource.odbcPassword = dataSource.password;
                                $scope.dataSource.practicePartnerProviders = dataSource.providers;
                                $scope.dataSource.appointmentStates = JSON.stringify(dataSource.appointmentStates);
                                break;
                            case "CrystalPM":
                                $scope.dataSource.crystalPMDataSourceURL = dataSource.dataSourceUrl;
                                $scope.dataSource.crystalPMUsername = dataSource.username;
                                $scope.dataSource.crystalPMPassword = dataSource.password;
                                $scope.dataSource.crystalPMPasscode = dataSource.passcode;
                                $scope.dataSource.crystalPMCommandPath = dataSource.commandPath;
                                $scope.dataSource.crystalPMFetchTrackableItems = dataSource.fetchTrackableItems;
                                $scope.dataSource.TraceInfo = dataSource.traceInfo;
                                break;
                            case "Rev360":
                                $scope.dataSource.rev360DataSourceUrl = dataSource.dataSourceUrl;
                                $scope.dataSource.rev360Username = dataSource.username;
                                $scope.dataSource.rev360Password = dataSource.password;
                                $scope.dataSource.rev360FetchTrackableItems = dataSource.fetchTrackableItems;
                                $scope.dataSource.TraceInfo = dataSource.traceInfo;
                                break;
                            case "Aprima":
                                $scope.dataSource.aprimaDataSourceUrl = dataSource.dataSourceUrl;
                                $scope.dataSource.aprimaUsername = dataSource.username;
                                $scope.dataSource.aprimaPassword = dataSource.password;
                                $scope.dataSource.appointmentStates = JSON.stringify(dataSource.appointmentStates);
                                $scope.dataSource.TraceInfo = dataSource.traceInfo;
                                $scope.dataSource.siteIds = dataSource.siteIds;
                                $scope.dataSource.logSystemInformation = dataSource.logSystemInformation;
                                $scope.dataSource.onlyFetchBillingProviders = dataSource.onlyFetchBillingProviders;
                                break;
                            case "ModMed":
                                $scope.dataSource.modmedUsername = dataSource.username;
                                $scope.dataSource.modmedPassword = dataSource.password;
                                $scope.dataSource.firmUrlPrefix = dataSource.firmUrlPrefix;
                                $scope.dataSource.modmedApiUrl = dataSource.baseApiUrl;
                                $scope.dataSource.modmedApiKey = dataSource.apiKey;
                                break;
                            case "Vetter":
                                $scope.dataSource.vetterApiKey = dataSource.apiKey;
                                $scope.dataSource.vetterClientId = dataSource.clientId;
                                $scope.dataSource.vetterApiUrl = dataSource.apiUrl;
                                $scope.dataSource.vetterClientSecret = dataSource.clientSecret;
                                $scope.dataSource.vetterVersion = dataSource.version;
                                $scope.dataSource.appointmentStates = JSON.stringify(dataSource.appointmentStates);
                                break;
                            case "OfficePracticum":
                                $scope.dataSource.officePApiUrl = dataSource.apiUrl;
                                $scope.dataSource.officePClientId = dataSource.clientId;
                                $scope.dataSource.authURL = dataSource.authURL;
                                $scope.dataSource.officePClientSecret = dataSource.clientSecret;
                                $scope.dataSource.resourceBatchSize = dataSource.resourceBatchSize;
                                $scope.dataSource.syncAppointmentsFromDaysBack = dataSource.syncAppointmentsFromDaysBack;
                                $scope.dataSource.syncAppointmentsFromDaysForward =
                                    dataSource.syncAppointmentsFromDaysForward;
                                break;
                            case "Dentally":
                                $scope.dataSource.dentallyBaseApiUrl = dataSource.baseApiUrl;
                                $scope.dataSource.accessToken = dataSource.accessToken;
                                $scope.dataSource.siteId = dataSource.siteId;
                                $scope.dataSource.started =
                                    dataSource.started && dataSource.started === "true" ? true : false;
                                break;
                            case "ACTData":
                                $scope.dataSource.actDataAccountId = dataSource.accountId;
                                $scope.dataSource.actDataModuleAdaptor = dataSource.moduleAdaptor;
                                $scope.dataSource.actDataBaseApiUrl = dataSource.apiBaseUrl;
                                $scope.dataSource.actDataAuthURL = dataSource.authUrl;
                                $scope.dataSource.actDataClientId = dataSource.clientId;
                                $scope.dataSource.actDataClientSecret = dataSource.clientSecret;
                                $scope.dataSource.actDataUsername = dataSource.username;
                                $scope.dataSource.actDataPassword = dataSource.password;
                                $scope.dataSource.actDataStarted =
                                    Boolean(dataSource.started) && dataSource.started.toString() === "true";
                                $scope.dataSource.actDataDisableAutomatedReconcile =
                                    Boolean(dataSource.disableAutomatedReconcile) &&
                                        dataSource.disableAutomatedReconcile.toString() === "true";
                                $scope.dataSource.actDataSyncAppointmentsFromDaysBack = $scope.getNumberFromString(dataSource.syncAppointmentsFromDaysBack);
                                $scope.dataSource.actDataSyncAppointmentsFromDaysForward = $scope.getNumberFromString(dataSource.syncAppointmentsFromDaysForward);
                                $scope.dataSource.actDataGenderMap = $scope.getJSONStringifyOrEmptyString(dataSource.genderMap);
                                $scope.dataSource.actDataAppointmentStates = $scope.getJSONStringifyOrEmptyString(dataSource.appointmentStates);
                                $scope.dataSource.actDataPhoneTypeMap = $scope.getJSONStringifyOrEmptyString(dataSource.phoneTypeMap);
                                $scope.dataSource.TraceInfo = dataSource.traceInfo;
                                $scope.dataSource.useTypeFieldForAppointmentReasons = dataSource.useTypeFieldForAppointmentReasons;
                                break;
                            case "Dentrix":
                                $scope.dataSource.dentrixDataSourceUrl = dataSource.dataSourceUrl;
                                $scope.dataSource.dentrixAppointmentStates = $scope.getJSONStringifyOrEmptyString(dataSource.appointmentStates);
                                $scope.dataSource.TraceInfo = dataSource.traceInfo;
                                $scope.dataSource.dentrixStarted =
                                    Boolean(dataSource.isStarted) && dataSource.isStarted.toString() === "true";
                                break;
                            case "Shepherd":
                                $scope.dataSource.shepherdBaseUrl = dataSource.baseUrl;
                                $scope.dataSource.publicKey = dataSource.publicKey;
                                $scope.dataSource.privateKey = dataSource.privateKey;
                                $scope.dataSource.clinicID = dataSource.clinicId;
                                $scope.dataSource.TraceInfo = dataSource.traceInfo;
                                break;
                            case "OpenDental":
                                $scope.dataSource.username = dataSource.username;
                                $scope.dataSource.password = dataSource.password;
                                $scope.dataSource.dataSourceUrl = dataSource.dataSourceUrl;
                                $scope.dataSource.TraceInfo = dataSource.traceInfo;
                                break;
                            case "Eaglesoft":
                                $scope.dataSource.username = dataSource.username;
                                $scope.dataSource.password = dataSource.password;
                                $scope.dataSource.dataSourceUrl = dataSource.dataSourceUrl;
                                $scope.dataSource.integrationKey = dataSource.integrationKey;
                                $scope.dataSource.TraceInfo = dataSource.traceInfo;
                                break;
                            case "Ascend":
                                $scope.dataSource.authUrl = dataSource.authUrl;
                                $scope.dataSource.baseUrl = dataSource.baseUrl;
                                $scope.dataSource.orgUrl = dataSource.orgUrl;
                                $scope.dataSource.clientId = dataSource.clientId;
                                $scope.dataSource.secretKey = dataSource.secretKey;
                                $scope.dataSource.TraceInfo = dataSource.traceInfo;
                                break;
                            case "Tab32":
                                $scope.dataSource.tab32ApiKey = dataSource.apiKey;
                                $scope.dataSource.tab32BaseUrl = dataSource.baseUrl;
                                break;
                        }
                        $scope.setInitialStateDataSource($scope.dataSource);
                    }
                };
                $scope.getJSONStringifyOrNull = function (value) {
                    if (Boolean(value)) {
                        return JSON.stringify(value);
                    }
                    return null;
                };
                $scope.getJSONParsedOrNull = function (value) {
                    if (Boolean(value)) {
                        return JSON.parse(value);
                    }
                    return null;
                };
                const actDataCondition = (dataSource, initialState) => {
                    if (dataSource.actDataSyncAppointmentsFromDaysBack !==
                        initialState.actDataSyncAppointmentsFromDaysBack ||
                        dataSource.actDataSyncAppointmentsFromDaysForward !==
                            initialState.actDataSyncAppointmentsFromDaysForward ||
                        dataSource.actDataStarted !== initialState.actDataStarted) {
                        return { updateMode: "fullnow" };
                    }
                    return null;
                };
                const getUpdateModeInstructionByModule = {
                    ACTData: actDataCondition,
                };
                $scope.getUpdateModeInstruction = function (dataSource, initialState) {
                    if (Boolean(getUpdateModeInstructionByModule[dataSource.moduleType])) {
                        return getUpdateModeInstructionByModule[dataSource.moduleType](dataSource, initialState);
                    }
                    return null;
                };
                $scope.getConfig = function (createNew) {
                    console.log("$scope.getConfig", $scope.dataSource);
                    var typeSpecificDataSourceJSON = {};
                    if ($scope.dataSource.appointmentStates !== undefined && $scope.dataSource.appointmentStates !== "") {
                        try {
                            JSON.parse($scope.dataSource.appointmentStates);
                        }
                        catch (e) {
                            $scope.viewModel.wrongAppointmentStates = true;
                        }
                    }
                    switch ($scope.dataSource.moduleType) {
                        case "MicroMD":
                            typeSpecificDataSourceJSON = {
                                servicePracticeName: $scope.dataSource.servicePracticeName,
                                serviceVirtualDatabase: $scope.dataSource.serviceVirtualDatabase,
                                serviceHostURL: $scope.dataSource.serviceHostURL,
                                servicePort: $scope.dataSource.servicePort,
                                serviceDatabase: $scope.dataSource.serviceDatabase,
                                appointmentStates: $scope.dataSource.appointmentStates !== undefined &&
                                    $scope.dataSource.appointmentStates !== ""
                                    ? JSON.parse($scope.dataSource.appointmentStates)
                                    : $scope.dataSource.appointmentStates,
                            };
                            break;
                        case "Lytec":
                            typeSpecificDataSourceJSON = {
                                dataSourceUrl: $scope.dataSource.lytecDataSourceURL,
                                username: $scope.dataSource.lytecUsername,
                                password: $scope.dataSource.lytecPassword,
                            };
                            break;
                        case "SolutionSeries":
                            typeSpecificDataSourceJSON = {
                                dataSourceUrl: $scope.dataSource.solutionSeriesDataSourceURL,
                                username: $scope.dataSource.solutionSeriesUsername,
                                password: $scope.dataSource.solutionSeriesPassword,
                            };
                            break;
                        case "MacPractice":
                            typeSpecificDataSourceJSON = {
                                dataSourceUrl: $scope.dataSource.macPracticeDataSourceURL,
                                username: $scope.dataSource.macPracticeUsername,
                                password: $scope.dataSource.macPracticePassword,
                                appointmentStates: $scope.dataSource.appointmentStates !== undefined &&
                                    $scope.dataSource.appointmentStates !== ""
                                    ? JSON.parse($scope.dataSource.appointmentStates)
                                    : $scope.dataSource.appointmentState,
                            };
                            if ($scope.dataSource.apiUsername !== undefined && $scope.dataSource.apiUsername !== "") {
                                typeSpecificDataSourceJSON.apiUsername = $scope.dataSource.apiUsername;
                                typeSpecificDataSourceJSON.apiPassword = $scope.dataSource.apiPassword || "";
                            }
                            break;
                        case "Medisoft":
                            typeSpecificDataSourceJSON = {
                                medisoftDatasourceName: $scope.dataSource.medisoftDatasourceName,
                                medisoftDataDirectory: $scope.dataSource.medisoftDataDirectory,
                                medisoftServerType: $scope.dataSource.medisoftServerType,
                                username: $scope.dataSource.medisoftUsername,
                                password: $scope.dataSource.medisoftPassword,
                                rescheduledWaitlistAsCancelled: $scope.dataSource.rescheduledWaitlistAsCancelled,
                            };
                            break;
                        case "Daisy":
                            typeSpecificDataSourceJSON = {
                                databaseName: $scope.dataSource.daisyDatabaseName,
                                serverHost: $scope.dataSource.daisyServerHost,
                                portNumber: $scope.dataSource.daisyServerPort,
                                username: $scope.dataSource.daisyUsername,
                                password: $scope.dataSource.daisyPassword,
                                httpUsername: $scope.dataSource.daisyHttpUsername,
                                httpPassword: $scope.dataSource.daisyHttpPassword,
                                traceInfo: $scope.dataSource.TraceInfo,
                                appointmentStates: $scope.dataSource.appointmentStates !== undefined &&
                                    $scope.dataSource.appointmentStates !== ""
                                    ? JSON.parse($scope.dataSource.appointmentStates)
                                    : $scope.dataSource.appointmentStates,
                            };
                            break;
                        case "PracticePartner":
                            try {
                                typeSpecificDataSourceJSON = {
                                    dbName: $scope.dataSource.odbcDatasourceName,
                                    username: $scope.dataSource.odbcUsername,
                                    password: $scope.dataSource.odbcPassword,
                                    providers: $scope.dataSource.practicePartnerProviders,
                                    appointmentStates: $scope.dataSource.appointmentStates !== undefined &&
                                        $scope.dataSource.appointmentStates !== ""
                                        ? JSON.parse($scope.dataSource.appointmentStates)
                                        : $scope.dataSource.appointmentStates,
                                };
                            }
                            catch (ex) {
                                console.error(ex);
                            }
                            break;
                        case "CrystalPM":
                            typeSpecificDataSourceJSON = {
                                dataSourceUrl: $scope.dataSource.crystalPMDataSourceURL,
                                username: $scope.dataSource.crystalPMUsername,
                                password: $scope.dataSource.crystalPMPassword,
                                passcode: $scope.dataSource.crystalPMPasscode,
                                fetchTrackableItems: $scope.dataSource.crystalPMFetchTrackableItems === undefined
                                    ? false
                                    : $scope.dataSource.crystalPMFetchTrackableItems,
                                traceInfo: $scope.dataSource.TraceInfo,
                            };
                            if ($scope.dataSource.crystalPMCommandPath !== undefined &&
                                $scope.dataSource.crystalPMCommandPath !== "") {
                                typeSpecificDataSourceJSON.commandPath = $scope.dataSource.crystalPMCommandPath;
                            }
                            break;
                        case "Rev360":
                            typeSpecificDataSourceJSON = {
                                dataSourceUrl: $scope.dataSource.rev360DataSourceUrl,
                                username: $scope.dataSource.rev360Username,
                                password: $scope.dataSource.rev360Password,
                                traceInfo: $scope.dataSource.TraceInfo,
                                fetchTrackableItems: $scope.dataSource.rev360FetchTrackableItems === undefined
                                    ? false
                                    : $scope.dataSource.rev360FetchTrackableItems,
                            };
                            break;
                        case "Aprima":
                            typeSpecificDataSourceJSON = {
                                dataSourceUrl: $scope.dataSource.aprimaDataSourceUrl,
                                username: $scope.dataSource.aprimaUsername,
                                password: $scope.dataSource.aprimaPassword,
                                appointmentStates: $scope.dataSource.appointmentStates !== undefined &&
                                    $scope.dataSource.appointmentStates !== ""
                                    ? JSON.parse($scope.dataSource.appointmentStates)
                                    : $scope.dataSource.appointmentStates,
                                traceInfo: $scope.dataSource.TraceInfo,
                                siteIds: $scope.dataSource.siteIds,
                                logSystemInformation: $scope.dataSource.logSystemInformation,
                                onlyFetchBillingProviders: Boolean($scope.dataSource.onlyFetchBillingProviders),
                            };
                            break;
                        case "ModMed":
                            typeSpecificDataSourceJSON = {
                                username: $scope.dataSource.modmedUsername,
                                password: $scope.dataSource.modmedPassword,
                                baseApiUrl: $scope.dataSource.modmedApiUrl,
                                apiKey: $scope.dataSource.modmedApiKey,
                                firmUrlPrefix: $scope.dataSource.firmUrlPrefix,
                            };
                            break;
                        case "Vetter":
                            typeSpecificDataSourceJSON = {
                                apiKey: $scope.dataSource.vetterApiKey,
                                clientId: $scope.dataSource.vetterClientId,
                                apiUrl: $scope.dataSource.vetterApiUrl,
                                clientSecret: $scope.dataSource.vetterClientSecret,
                                version: $scope.dataSource.vetterVersion,
                                appointmentStates: $scope.dataSource.appointmentStates !== undefined &&
                                    $scope.dataSource.appointmentStates !== ""
                                    ? JSON.parse($scope.dataSource.appointmentStates)
                                    : $scope.dataSource.appointmentStates,
                            };
                            break;
                        case "OfficePracticum":
                            typeSpecificDataSourceJSON = {
                                clientId: $scope.dataSource.officePClientId,
                                apiUrl: $scope.dataSource.officePApiUrl,
                                clientSecret: $scope.dataSource.officePClientSecret,
                                authURL: $scope.dataSource.authURL,
                                resourceBatchSize: $scope.dataSource.resourceBatchSize,
                                syncAppointmentsFromDaysBack: $scope.dataSource.syncAppointmentsFromDaysBack,
                                syncAppointmentsFromDaysForward: $scope.dataSource.syncAppointmentsFromDaysForward,
                            };
                            break;
                        case "Dentally":
                            typeSpecificDataSourceJSON = {
                                baseApiUrl: $scope.dataSource.dentallyBaseApiUrl,
                                accessToken: $scope.dataSource.accessToken,
                                siteId: $scope.dataSource.siteId,
                                started: $scope.dataSource.started ? $scope.dataSource.started : false,
                            };
                            break;
                        case "ACTData":
                            typeSpecificDataSourceJSON = {
                                accountId: $scope.dataSource.actDataAccountId,
                                moduleAdaptor: $scope.dataSource.actDataModuleAdaptor,
                                apiBaseUrl: $scope.dataSource.actDataBaseApiUrl,
                                authUrl: $scope.dataSource.actDataAuthURL,
                                clientId: $scope.dataSource.actDataClientId,
                                clientSecret: $scope.dataSource.actDataClientSecret,
                                username: $scope.dataSource.actDataUsername,
                                password: $scope.dataSource.actDataPassword,
                                started: Boolean($scope.dataSource.actDataStarted),
                                disableAutomatedReconcile: Boolean($scope.dataSource.actDataDisableAutomatedReconcile),
                                syncAppointmentsFromDaysBack: $scope.dataSource.actDataSyncAppointmentsFromDaysBack,
                                syncAppointmentsFromDaysForward: $scope.dataSource.actDataSyncAppointmentsFromDaysForward,
                                appointmentStates: $scope.getJSONParsedOrNull($scope.dataSource.actDataAppointmentStates),
                                genderMap: $scope.getJSONParsedOrNull($scope.dataSource.actDataGenderMap),
                                phoneTypeMap: $scope.getJSONParsedOrNull($scope.dataSource.actDataPhoneTypeMap),
                                useTypeFieldForAppointmentReasons: Boolean($scope.dataSource.useTypeFieldForAppointmentReasons),
                                traceInfo: Boolean($scope.dataSource.TraceInfo),
                            };
                            $scope.viewModel.setToFull = $scope.dataSource.actDataStarted
                                ? true
                                : $scope.viewModel.setToFull;
                            break;
                        case "Dentrix":
                            typeSpecificDataSourceJSON = {
                                dataSourceUrl: $scope.dataSource.dentrixDataSourceUrl,
                                appointmentStates: $scope.getJSONParsedOrNull($scope.dataSource.dentrixAppointmentStates),
                                traceInfo: Boolean($scope.dataSource.TraceInfo),
                                isStarted: Boolean($scope.dataSource.dentrixStarted),
                            };
                            break;
                        case "Shepherd":
                            typeSpecificDataSourceJSON = {
                                baseUrl: $scope.dataSource.shepherdBaseUrl,
                                publicKey: $scope.dataSource.publicKey,
                                traceInfo: Boolean($scope.dataSource.TraceInfo),
                                privateKey: $scope.dataSource.privateKey,
                                clinicId: $scope.dataSource.clinicID,
                            };
                            break;
                        case "OpenDental":
                            typeSpecificDataSourceJSON = {
                                dataSourceUrl: $scope.dataSource.dataSourceUrl,
                                username: $scope.dataSource.username,
                                traceInfo: Boolean($scope.dataSource.TraceInfo),
                                password: $scope.dataSource.password
                            };
                            break;
                        case "Eaglesoft":
                            typeSpecificDataSourceJSON = {
                                dataSourceUrl: $scope.dataSource.dataSourceUrl,
                                username: $scope.dataSource.username,
                                traceInfo: Boolean($scope.dataSource.TraceInfo),
                                password: $scope.dataSource.password,
                                integrationKey: $scope.dataSource.integrationKey
                            };
                            break;
                        case "Ascend":
                            typeSpecificDataSourceJSON = {
                                authUrl: $scope.dataSource.authUrl,
                                baseUrl: $scope.dataSource.baseUrl,
                                traceInfo: Boolean($scope.dataSource.TraceInfo),
                                orgUrl: $scope.dataSource.orgUrl,
                                clientId: $scope.dataSource.clientId,
                                secretKey: $scope.dataSource.secretKey,
                            };
                            break;
                        case "Tab32":
                            typeSpecificDataSourceJSON = {
                                baseUrl: $scope.dataSource.tab32BaseUrl,
                                traceInfo: Boolean($scope.dataSource.TraceInfo),
                                apiKey: $scope.dataSource.tab32ApiKey,
                            };
                            break;
                    }
                    // add to datasource only if the value is true - since the Satellite will not use it if defaults to false.
                    typeSpecificDataSourceJSON.traceInfo = $scope.dataSource.TraceInfo
                        ? $scope.dataSource.TraceInfo
                        : undefined;
                    typeSpecificDataSourceJSON.lastModifiedSearchOffsetHours = $scope.dataSource
                        .lastModifiedSearchOffsetHours
                        ? $scope.dataSource.lastModifiedSearchOffsetHours
                        : undefined;
                    var module = {};
                    if (createNew) {
                        module = {
                            //"clientModuleId": $scope.viewModel.selectedClientModule.clientModuleId,
                            //"autoremindAccount": $scope.viewModel.selectedClientModule.autoremindAccount,
                            autoremindAccount: $scope.dataSource.autoremindAccount,
                            //"updateMode": $scope.viewModel.selectedClientModule.updateMode,
                            updateMode: $scope.dataSource.updateMode,
                            //"updateInterval": $scope.viewModel.selectedClientModule.updateInterval, // Include only because the servlet saves all details
                            updateInterval: $scope.dataSource.updateInterval,
                            moduleName: $scope.dataSource.moduleName,
                            moduleType: $scope.dataSource.moduleType,
                            instructionsJSON: { updateInterval: $scope.dataSource.updateInterval },
                            dataSourceJSON: typeSpecificDataSourceJSON,
                        };
                    }
                    else {
                        module = {
                            clientModuleId: $scope.viewModel.selectedClientModule.clientModuleId,
                            //"autoremindAccount": $scope.viewModel.selectedClientModule.autoremindAccount,
                            autoremindAccount: $scope.dataSource.autoremindAccount,
                            updateMode: $scope.viewModel.selectedClientModule.updateMode,
                            // updateMode: $scope.dataSource.updateMode,
                            //"updateInterval": $scope.viewModel.selectedClientModule.updateInterval, // Include only because the servlet saves all details
                            updateInterval: $scope.dataSource.updateInterval,
                            moduleName: $scope.dataSource.moduleName,
                            moduleType: $scope.dataSource.moduleType,
                            instructionsJSON: { updateInterval: $scope.dataSource.updateInterval },
                            dataSourceJSON: typeSpecificDataSourceJSON,
                        };
                    }
                    return module;
                };
                $scope.addSatellite = function () {
                    $scope.increaseLoadingIndicator();
                    satelliteService.addSatellite($scope.viewModel.selectedUser.userName).then(function (satellites) {
                        //alert('A new client module config has been created on the server. Please wait for the Satellite to get the syncronize and test the settings.');
                        $scope.decreaseLoadingIndicator();
                        $scope.getSatellites(false, "The satellite configuration has been deleted. If you log in from the Satellite on the client system it will be created again unless you uninstall from the client system.");
                    });
                };
                $scope.addClientModule = function (forceSave) {
                    // NOTE: updateMode and updateInterval are not set via instructionsJSON when creating a new module
                    var module = $scope.getConfig(true);
                    var dataSourceCopy = Object.assign(Object.assign({}, $scope.dataSource), { clientModuleId: 0 });
                    var promise1 = $scope.executeCheckingModuleName(dataSourceCopy);
                    var promise2 = $scope.executeCheckingUserAlreadyHaveDatasource();
                    $q.all([promise1, promise2]).then(function () {
                        $scope.increaseLoadingIndicator();
                        satelliteService
                            .saveClientModule($scope.viewModel.selectedSatellite.satelliteId, module, forceSave)
                            .then(function (response) {
                            $scope.decreaseLoadingIndicator();
                            if (angular.isDefined(response.error)) {
                                if (response.error === "warnDuplicateModuleForAccount") {
                                    var dialog = dialogs.confirm("Confirm", "A data source is already registered for this account. " +
                                        "Are you sure you want to add another?");
                                    dialog.result.then(function (button) {
                                        // Yes
                                        $scope.addClientModule(true); // Try again and force adding
                                    }, function (button) {
                                        // No
                                    });
                                }
                            }
                            else {
                                $scope.viewModel.selectedClientModule = null;
                                $scope.dataSource.initialized = false;
                                $scope.clearDataSource();
                                dialogs.notify("Success", "A new client module config has been created on the server. Please wait for the Satellite to syncronize and test the settings.");
                            }
                            //TODO: Auto-select new (ref is moduleName) when loaded
                        }, function (error) {
                            $scope.viewModel.isError = true;
                            $scope.viewModel.error = error.error.reason;
                            $scope.viewModel.errorMessage = "Internal Server Error";
                            $scope.showError();
                            deferred.reject(error);
                        });
                    });
                };
                $scope.showError = function () {
                    var msg = $scope.viewModel.isError ? $scope.viewModel.error : "Some sort of unexpected error!";
                    dialogs.notify($scope.viewModel.errorMessage, msg);
                };
                $scope.saveClientModuleConfig = function (forceSave) {
                    // NOTE: updateMode and updateInterval are not set via instructionsJSON when creating a new module
                    var module = $scope.getConfig(false);
                    // For ACTData some params means resetting it to full
                    module.instructionsJSON = Object.assign(Object.assign({}, module.instructionsJSON), $scope.getUpdateModeInstruction($scope.dataSource, $scope.initialSateDataSource));
                    // For  ACTData is needed to prevent save
                    if ($scope.preventDecreasingValue("actDataSyncAppointmentsFromDaysForward", "Sync Appointments From Days Forward", module.moduleType)) {
                        return;
                    }
                    $scope.increaseLoadingIndicator();
                    satelliteService
                        .saveClientModule($scope.viewModel.selectedSatellite.satelliteId, module, forceSave)
                        .then(function (response) {
                        $scope.decreaseLoadingIndicator();
                        if (angular.isDefined(response.error)) {
                            if (response.error === "warnDuplicateModuleForAccount") {
                                var dialog = dialogs.confirm("Confirm", "A data source is already registered for this account. " +
                                    "Are you sure you want to add this data source to the account?");
                                dialog.result.then(function (button) {
                                    // Yes
                                    $scope.saveClientModuleConfig(true); // Try again and force adding
                                }, function (button) {
                                    // No
                                });
                            }
                        }
                        else {
                            dialogs.notify("Success", "A request to save settings for the client module has been sent. " +
                                "Please wait for the Satellite to syncronize and test the settings.");
                            $scope.setInitialStateDataSource($scope.dataSource);
                        }
                    });
                };
                /**
                 *
                 */
                $scope.setClientModuleUpdateMode = function (clientModule, newMode) {
                    if (clientModule.updateMode !== newMode) {
                        var module = {
                            clientModuleId: clientModule.clientModuleId,
                            instructionsJSON: { updateMode: newMode },
                        };
                        satelliteService.saveClientModule(clientModule.satelliteId, module);
                    }
                };
                /**
                 *
                 */
                $scope.togglePause = function (clientModule, newMode) {
                    if (clientModule.updateMode !== newMode) {
                        var module = {
                            clientModuleId: clientModule.clientModuleId,
                            instructionsJSON: { updateMode: newMode },
                        };
                        $scope.increaseLoadingIndicator();
                        satelliteService.saveClientModule(clientModule.satelliteId, module).then(function () {
                            $scope.decreaseLoadingIndicator();
                            dialogs.notify("Success", "A request to " +
                                newMode +
                                " resume updating of the client module has been sent. " +
                                "Please wait for the Satellite to get the request and make the change.");
                        }) /*
                            .error(function(data, status) {
                            alert('Failed! status: ' + status);
                            })*/;
                    }
                };
                /**
                 *
                 */
                $scope.cancelClientModuleUpdate = function (clientModule) {
                    $scope.increaseLoadingIndicator();
                    var newMode = "cancel";
                    if (clientModule.updateMode !== newMode) {
                        var module = {
                            clientModuleId: clientModule.clientModuleId,
                            instructionsJSON: { updateMode: newMode },
                        };
                        satelliteService.saveClientModule(clientModule.satelliteId, module).then(function () {
                            $scope.decreaseLoadingIndicator();
                            dialogs.notify("Success", "A request to cancel full update (switching to normal mode) has been sent. " +
                                "Please wait for the Satellite to get the request and make the change.");
                        });
                    }
                };
                /**
                 *
                 */
                $scope.rebuild = function (clientModule) {
                    $scope.increaseLoadingIndicator();
                    var newMode = "fullnow";
                    if (clientModule.updateMode !== newMode) {
                        var module = {
                            clientModuleId: clientModule.clientModuleId,
                            instructionsJSON: { updateMode: newMode },
                        };
                        satelliteService.saveClientModule(clientModule.satelliteId, module).then(function () {
                            $scope.decreaseLoadingIndicator();
                            dialogs.notify("Success", "A request to cancel current update and restart in full update mode has been sent. " +
                                "Please wait for the Satellite to get the request and make the change.");
                        });
                    }
                };
                /**
                 *
                 */
                $scope.deleteClientModule = function (clientModule) {
                    $scope.increaseLoadingIndicator();
                    satelliteService
                        .deleteClientModule($scope.viewModel.selectedSatellite.satelliteId, clientModule.clientModuleId)
                        .then(function () {
                        $scope.decreaseLoadingIndicator();
                        if ($scope.viewModel.selectedClientModule.clientModuleId === clientModule.clientModuleId) {
                            $scope.viewModel.selectedClientModule = null;
                            $scope.clearDataSource();
                        }
                        dialogs.notify("Success", "A request to delete the client module has been sent. " +
                            "Please wait for the Satellite to get the request and make the change.");
                        //TODO: Inform user that the Satellite does not delete
                    });
                };
                /**
                 *
                 */
                $scope.deleteSatellite = function (satellite) {
                    var dialog = dialogs.confirm("Confirm", "Are you sure you want to delete the satellite configuration?");
                    dialog.result.then(function (button) {
                        // Yes
                        $scope.increaseLoadingIndicator();
                        satelliteService.deleteSatellite(satellite.satelliteId).then(function () {
                            $scope.decreaseLoadingIndicator();
                            $scope.getSatellites(true, "The satellite configuration has been deleted. " +
                                "If you log in from the Satellite on the client system it will be created again " +
                                "unless you uninstall from the client system.");
                        });
                    }, function (button) {
                        // No
                    });
                };
                /**
                 *
                 */
                $scope.resetSatellite = function (satellite) {
                    var dialog = dialogs.confirm("Confirm", "Are you sure you want to reset the satellite ID? " +
                        "This is necessary in case the Satellite is moved to a different machine and/or MAC address " +
                        "thus generating a new Satellite ID.  After this you have to enter username and password again " +
                        "on the Satellite on the Satellite machine.");
                    dialog.result.then(function (button) {
                        // Yes
                        $scope.increaseLoadingIndicator();
                        satelliteService.resetSatellite(satellite.satelliteId).then(function () {
                            $scope.decreaseLoadingIndicator();
                            $scope.getSatellites("The satellite ID has been reset. " +
                                "You need to enter username and password on the Satellite in order to connect/re-connect.");
                        });
                    }, function (button) {
                        // No
                    });
                };
                $scope.getLogEvents = function (satellite) {
                    $scope.viewModel.satelliteErrorSort = { column: "eventId", descending: true };
                    $scope.increaseLoadingIndicator();
                    $scope.viewModel.logEventLoadingIndicator = true;
                    if (!angular.isDefined($scope.viewModel.lastLogEventId)) {
                        $scope.viewModel.lastLogEventId = 0;
                        $scope.viewModel.firstLogEventId = 0;
                        $scope.viewModel.logEvents = [];
                    }
                    satelliteService
                        .getLogEventsBySatelliteId(satellite.satelliteId, $scope.viewModel.lastLogEventId, $scope.viewModel.firstLogEventId)
                        .then(function (response) {
                        var logEvents = response.events;
                        $scope.decreaseLoadingIndicator();
                        $scope.viewModel.logEventLoadingIndicator = false;
                        if ($scope.viewModel.logEvents.length === 0) {
                            $scope.viewModel.logEvents = logEvents;
                        }
                        else {
                            for (var i = 0; i < logEvents.length; i++) {
                                $scope.viewModel.logEvents.push(logEvents[i]);
                            }
                        }
                        if (logEvents !== undefined && logEvents.length !== 0) {
                            $scope.viewModel.lastLogEventId = response.lastLogEventId;
                            $scope.viewModel.firstLogEventId =
                                $scope.viewModel.firstLogEventId === 0 ||
                                    $scope.viewModel.firstLogEventId < logEvents[0].eventId
                                    ? logEvents[0].eventId
                                    : $scope.viewModel.firstLogEventId;
                        }
                    }, function () {
                        $scope.decreaseLoadingIndicator();
                        $scope.viewModel.logEventLoadingIndicator = false;
                    });
                };
                $scope.selectLogEvent = function (logEvent, index) {
                    if ($scope.viewModel.selectedLogEvent === logEvent) {
                        $scope.viewModel.selectedLogEvent = null;
                        return;
                    }
                    $scope.viewModel.selectedLogEvent = logEvent;
                };
                $scope.updateTick = 0;
                $scope.checkSatelliteVersion = function (currentVersion) {
                    if (!currentVersion) {
                        return true;
                    }
                    return $scope.isSatelliteVersionLowerThan("0.10.753", currentVersion);
                };
                $scope.isSatelliteVersionLowerThan = function (versionFrom, currentVersion) {
                    const [versionFrom_Major, versionFrom_Minor, versionFrom_Path] = versionFrom
                        .split(".")
                        .map((number) => parseInt(number));
                    const [currentMajor, currentMinor, currentPatch] = currentVersion
                        .split(".")
                        .map((number) => parseInt(number));
                    if (currentMajor > versionFrom_Major)
                        return false;
                    if (currentMajor < versionFrom_Major)
                        return true;
                    if (currentMinor > versionFrom_Minor)
                        return false;
                    if (currentMinor < versionFrom_Minor)
                        return true;
                    return currentPatch < versionFrom_Path;
                };
                $scope.canEnableLoadStrategy = function (version) {
                    if (!version) {
                        return true;
                    }
                    var versionSections = version.split(".");
                    return parseInt(versionSections[2]) < $scope.minimumSatelliteVersion;
                };
                $scope.$on("$destroy", function () {
                    $scope.viewModel.selectedSatellite = null;
                    $scope.viewModel.satellites = [];
                    $scope.stopUpdate();
                    if ($scope.updateInterval) {
                        $interval.cancel($scope.updateInterval);
                    }
                });
                $rootScope.$on("event:auth-logout", function () {
                    $scope.viewModel.selectedSatellite = null;
                    $scope.viewModel.satellites = [];
                    $scope.stopUpdate();
                    if ($scope.updateInterval) {
                        $interval.cancel($scope.updateInterval);
                    }
                });
                var _timeout;
                $scope.checkModulName = function (dataSource) {
                    if (_timeout) {
                        $timeout.cancel(_timeout);
                    }
                    _timeout = $timeout(function () {
                        _timeout = null;
                        $scope.executeCheckingModuleName(dataSource);
                    }, 1000);
                };
                $scope.executeCheckingModuleName = function (dataSource) {
                    $scope.viewModel.isCheckingModulename = true;
                    var deferred = $q.defer();
                    satelliteService.checkModulName(dataSource, $scope.viewModel.selectedSatellite).then(function (data) {
                        $scope.viewModel.isCheckingModulename = false;
                        if (angular.isDefined(data.modulesWithSameModuleNameCount) &&
                            data.modulesWithSameModuleNameCount === 0) {
                            $scope.viewModel.isModulenameCanBeEdited = true;
                            deferred.resolve(data);
                        }
                        else {
                            $scope.viewModel.isModulenameCanBeEdited = false;
                            deferred.reject(data);
                        }
                    }, function (error) {
                        deferred.reject(error);
                    });
                    return deferred.promise;
                };
                $scope.executeCheckingUserAlreadyHaveDatasource = function () {
                    var deferred = $q.defer();
                    satelliteService
                        .checkIfUserAlreadyHaveDatasource($scope.viewModel.autoremindAccount, $scope.dataSource.moduleName, $scope.viewModel.loadingIndicatorv2)
                        .then(function (response) {
                        if (!response.exist) {
                            $scope.viewModel.disableSave = false;
                            deferred.resolve();
                        }
                        else {
                            dialogs.notify("Alert", 'A datasource with account name: "' +
                                $scope.viewModel.autoremindAccount +
                                '" already exists for autoremind account(s):.' +
                                response.accountForWhichSatelliteHaveDatasource);
                            $scope.viewModel.disableSave = true;
                            deferred.reject();
                        }
                    }, function (error) {
                        deferred.reject(error);
                    });
                    return deferred.promise;
                };
                $scope.enableLoadStrategyFromSatellite = function (clientModule) {
                    $scope.increaseLoadingIndicator();
                    var module = {
                        clientModuleId: clientModule.clientModuleId,
                        instructionsJSON: { enableLoadStrategyFromSatellite: true },
                    };
                    if ($scope.viewModel.selectedUser.hasStrategies) {
                        var dialog = dialogs.confirm("Confirm", "Central already has strategy details and these will not be overwritten by " +
                            "requesting again from Satellite. Only request again in rare cases you know of some strategy details not yet " +
                            "received from the Satellite. Are you sure you want to request again from Satellite?");
                        dialog.result.then(function (button) {
                            $scope.loadStrategyFromSatellite(module);
                        });
                    }
                    else {
                        $scope.loadStrategyFromSatellite(module);
                    }
                };
                $scope.loadStrategyFromSatellite = function (module) {
                    $scope.increaseLoadingIndicator();
                    $scope.viewModel.enableLoadStrategy = true;
                    satelliteService.enableLoadStrategyFromSatellite(module).then(function () {
                        $scope.decreaseLoadingIndicator();
                        dialogs.notify("Success", "A request to load strategy details from Satellite has been sent. " +
                            "Please wait for the Satellite to complete a full update and switch to normal mode.");
                    }, function (error) {
                        $scope.decreaseLoadingIndicator();
                        deferred.reject(error);
                    });
                };
                $scope.init = function () {
                    $scope.stopUpdate();
                    // $scope.viewModel.selectedSatellite = null;
                    satelliteService.getDatasourcesDefaults($scope.viewModel.loadingIndicatorv2).then(function (data) {
                        $scope.viewModel.defDataSources = angular.copy(data.datasourcesDefaults);
                        $scope.clearDataSource();
                        console.log("getDatasourcesDefaults", data);
                    });
                };
                $scope.hasBeenActivatedOnce = false;
                $scope.$watch("activated", function (newActivated, oldActivated) {
                    if (newActivated && !$scope.hasBeenActivatedOnce) {
                        $scope.hasBeenActivatedOnce = true;
                        if (!$scope.parentViewModel.selectedUserInfo) {
                            // If no user selected yet - indicate that we're waiting for user to be loaded
                            //$scope.increaseLoadingIndicator();
                        }
                        $scope.init();
                        // In case user has already been loaded (e.g. while another tab was selected
                        // then we need to load data here since observer below did not
                        if ($scope.parentViewModel.selectedUserInfo) {
                            $scope.viewModel.selectedUser = $scope.parentViewModel.selectedUserInfo;
                            $scope.getSatellites(false);
                        }
                    }
                    else if (newActivated) {
                        $scope.getSatellites(false);
                    }
                });
                // "observe" when user is fully loaded (because we need userName - not only userId)
                $scope.$watch("parentViewModel.selectedUserInfo", function (newUser, oldUser) {
                    if (newUser && newUser !== oldUser) {
                        // The loading indicator should be updated as soon we change/search user
                        if (oldUser && newUser !== oldUser) {
                            $scope.viewModel.logEventLoadingIndicator = false;
                            $scope.viewModel.lastLogEventId = 0;
                            $scope.viewModel.firstLogEventId = 0;
                            $scope.viewModel.logEvents = [];
                        }
                        if ($scope.activated) {
                            //$scope.decreaseLoadingIndicator();
                            $scope.viewModel.selectedUser = newUser;
                            $scope.getSatellites(false);
                        }
                    }
                });
                $scope.openConnectionProfileDialog = function (connectionProfile) {
                    storeDowngraded.dispatch(ConnectionProfilesActions.openConnectionProfileDialog({
                        autoremindAccount: $scope.viewModel.selectedUser.userName,
                        selectedConnectionProfile: connectionProfile,
                    }));
                    var subscribe = connectionProfilesSelectorsDowngraded
                        .selectIsUpdated()
                        .subscribe(function (isUpdated) {
                        if (isUpdated) {
                            $scope.getSatellites(false);
                        }
                    });
                };
                $scope.clearAutoremindAccound = function () {
                    $scope.viewModel.autoremindAccount = undefined;
                };
                const hasAppointments = () => {
                    return $scope.viewModel.selectedClientModule.appointmentCount > 0;
                };
                const isDataSourcePaused = () => {
                    return $scope.viewModel.selectedClientModule.updateMode === "pause";
                };
                $scope.preventDecreasingValue = function (variableName, label, moduleType) {
                    const hasAppointments = () => $scope.viewModel.selectedClientModule.appointmentCount > 0;
                    const isDataSourcePaused = () => $scope.viewModel.selectedClientModule.updateMode === "pause";
                    if (moduleType === "ACTData" &&
                        (!Boolean($scope.dataSource[variableName]) ||
                            $scope.dataSource[variableName] < $scope.initialSateDataSource[variableName]) &&
                        (hasAppointments() || !isDataSourcePaused())) {
                        $scope.dataSource[variableName] = $scope.initialSateDataSource[variableName];
                        dialogs.notify("Invalid operation", `To decrease the value of "${label}" first pause your data source and delete appointments if exist`);
                        return true;
                    }
                    return false;
                };
            },
        };
    },
]);
//# sourceMappingURL=satellite-setup.directive.js.map